import {Currency, PaymentChannel, PaymentMethod} from '.cache/__types__';
import {FormattedMessage} from 'react-intl';

export const walletMinimumPrice: Record<Currency, number> = {
    [Currency.Czk]: 500,
    [Currency.Eur]: 10,
};

export const walletMaximumPrice: Record<Currency, number> = {
    [Currency.Czk]: 15000,
    [Currency.Eur]: 400,
};

export const walletPaymentMethod = 'wallet';

export const payUCardMethods = [PaymentChannel.C];

export const payUInternetBankingMethods = [
    PaymentChannel.Cs,
    PaymentChannel.Kb,
    PaymentChannel.Ma,
    PaymentChannel.Mo,
    PaymentChannel.Mp,
    PaymentChannel.Pf,
    PaymentChannel.Pg,
    PaymentChannel.Pv,
    PaymentChannel.Rf,
    PaymentChannel.Cb,
    PaymentChannel.Era,
    PaymentChannel.Uc,
    PaymentChannel.Viamo,
    PaymentChannel.Uni,
    PaymentChannel.Vub,
    PaymentChannel.Sporo,
    PaymentChannel.Ceko,
    PaymentChannel.Posta,
    PaymentChannel.Tatra,
];

export const payUTransferMethods = [PaymentChannel.Bt];

export const payUTechCompPaymentMethods = [PaymentChannel.Ap, PaymentChannel.Jp];

export const paymentMethodTranslations = {
    [PaymentMethod.Campaign]: <FormattedMessage defaultMessage={'Kampaň'} />,
    [PaymentMethod.Cash]: <FormattedMessage defaultMessage={'Hotově'} />,
    [PaymentMethod.Invoice]: <FormattedMessage defaultMessage={'Faktura'} />,
    [PaymentMethod.InvoiceProforma]: <FormattedMessage defaultMessage={'Proforma faktura'} />,
    [PaymentMethod.MallPay]: <FormattedMessage defaultMessage={'Mall Pay'} />,
    [PaymentMethod.Payu]: <FormattedMessage defaultMessage={'Bankovní převod'} />,
    [PaymentMethod.ProblemSolved]: <FormattedMessage defaultMessage={'Vyřešení problému'} />,
    [PaymentMethod.Reclaim]: <FormattedMessage defaultMessage={'Reklamace'} />,
    [PaymentMethod.ReclaimBasicAccount]: <FormattedMessage defaultMessage={'Reklamace účtu'} />,
    [PaymentMethod.ReclaimPremiumAccount]: <FormattedMessage defaultMessage={'Reklamace účtu'} />,
    [PaymentMethod.ReclaimService]: <FormattedMessage defaultMessage={'Reklamace služby'} />,
    [PaymentMethod.Sms]: <FormattedMessage defaultMessage={'SMS'} />,
    [PaymentMethod.Wallet]: <FormattedMessage defaultMessage={'Peněženka'} />,
};
